"use client"

import * as DialogPrimitive from "@radix-ui/react-dialog"
import { useTranslation } from "react-i18next"
import CloseIcon from "@/assets/svg/close-icon.svg"
import {
	Dialog,
	DialogClose,
	DialogOverlay,
	DialogPortal,
	DialogTitle,
} from "@/components/ui/dialog"
import { QRCode } from "@/components/ui/qr-code"

interface PickupCodeDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	pickupCode: string
	redemptionCode: string
}

export function PickupCodeDialog({
	open,
	onOpenChange,
	pickupCode,
	redemptionCode,
}: PickupCodeDialogProps) {
	const { t } = useTranslation()

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogPortal>
				<DialogOverlay />
				<DialogPrimitive.Content className="pt-11 md:pt-12 px-5 pb-8 md:pb-12 w-81 md:w-full  md:max-w-135    bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-100 grid  max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%]  rounded-none  duration-200 sm:max-w-lg">
					<DialogTitle className="text-center text-px16 md:text-px22 leading-5 md:leading-10 ">
						{t("pickup.code.title")}
					</DialogTitle>
					<div className="flex flex-col items-center ">
						{/* 取货码 */}
						<div className="text-center">
							<div className="text-px24 md:text-px32 md:leading-12 font-bold text-foreground mt-2 md:mt-3">
								{pickupCode}
							</div>
						</div>

						{/* 二维码图标 */}
						<QRCode
							className="size-41 md:size-68 mt-8 md:mt-11"
							value={redemptionCode}
						/>

						{/* 扫码说明文字 */}
						<div className="mt-3 md:mt-4 text-center text-px16 md:text-px20 leading-5 md:leading-7 text-foreground font-semibold">
							{t("pickup.scan.description")}
						</div>

						{/* 兑换码标题和代码 */}
						<div className="mt-6 md:mt-8 text-center text-px14 text md:text-px18 text-foreground font-bold">
							{t("pickup.redemption.title")}: {redemptionCode}
						</div>

						{/* 说明文字 */}
						<div className="mt-2 md:mt-3 text-center text-px11 md:text-px16 text-muted-foreground leading-3.75 md:leading-5.5 whitespace-pre-line">
							{t("pickup.code.description")}
						</div>
					</div>
					<DialogClose>
						<CloseIcon className="absolute size-5.5 md:size-6 top-3 right-3 md:top-4 md:right-4" />
					</DialogClose>
				</DialogPrimitive.Content>
			</DialogPortal>
		</Dialog>
	)
}
